import React from "react";
import { Box } from "../../../components";
import { withProcedureWraper } from "..";
import DepartmentList from "./components/department-list";

const DepartmentsPage = withProcedureWraper(() => {
  return (
    <div style={{ margin: "42px 20px 0 20px", height: "100%" }}>
      <Box title="Phòng ban" style={{ height: "calc(100vh - 176px)" }}>
        <DepartmentList />
      </Box>
    </div>
  );
});

export default DepartmentsPage;
